import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-l-loading",
  "use": "icon-l-loading-usage",
  "viewBox": "0 0 165 165",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 165 165\" id=\"icon-l-loading\"><path d=\"M82.5 15v2c36.117 0 65.5 29.383 65.5 65.5S118.617 148 82.5 148 17 118.617 17 82.5A65.1 65.1 0 0 1 23.074 55h-2.195A67.1 67.1 0 0 0 15 82.5c0 37.22 30.28 67.5 67.5 67.5S150 119.72 150 82.5 119.72 15 82.5 15\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol